<template>
	<div>
		<!-- <el-upload action="" :http-request="upload"  :accept="accepttypes"  multiple :on-remove="handleRemove" :before-upload="beforeAvatarUpload" :file-list="fileList" >
            <el-button size="small" type="primary">选择文件</el-button>            
        </el-upload> -->
		<a href="javascript:;" class="file" style="float:left;">选择文件
			<input type="file" @change="filechange" :accept="accepttypes" multiple="multiple" ref="files" />
		</a>

	</div>
</template>

<script>
	export default {
		props: {
			disabled: Boolean,
			upload: Function,
			filename: {
				type: String,
				default: null
			},
			acceptType: {
				type: String,
				default: '.txt,.pdf,.docx,.doc,.xls,.ppt,.jpg,.jpeg,.png,gif,.bmp,.3GP,.avi,.flv,.mp4,.asf,.wmv,.mkv,.mov,.ts,.mxf,.webm'
			},
			maxFileSize: {
				type: Number,
				default: 300000000
			},

		},
		data() {
			return {
				accepttypes: this.acceptType,
				Progress: 0,
				progressShow: false,
				fileList: [],
				error: {
					has: false,
					msg: ''
				},
				messages: {
					acceptFileTypes: '不允许的文件类型',
					maxFileSize: '文件太大',
					minFileSize: '文件太小',
					document: '限.doc/.docx/.xls/.xlsx/.txt/.pdf/.rar/.zip格式的文件',
					all: '限.doc/.docx/.xls/.xlsx/.txt/.pdf/.rar/.zip格式的文件',
					image: '限jpg,pgn,gif格式的图片',
					audio: '限mp3、m4a、wma格式的音频',
					video: '限.mp4/格式的视频',
					pdf: '限.pdf格式的文件'
				},
			}
		},
		watch: {
			filename(val) {
				if(val && val !== '') {
					this.fileList = [{
						name: val
					}]
				} else {
					this.fileList = [];
				}
			},
			acceptType(val, oldval) {
				if(val !== '' && val !== oldval) {
					this.clear();
				}
			}
		},
		mounted() {
			if(this.filename && this.filename !== '') {
				this.fileList = [{
					name: this.filename
				}]
			} else {
				this.fileList = [];
			}
		},
		methods: {
			filechange() {
				let files = this.$refs.files.files;
				let newfilesarray = [];
				for(let index = 0; index < files.length; index++) {
					let element = files[index];
					if(element.size > this.maxFileSize) {
						this.$message(element.filename + "文件大小超过300M");

					} else {
						newfilesarray.push(element);
					}
				};
				this.$emit('upload', newfilesarray);
			}

		}
	}
</script>

<style type="text/css" lang="scss" rel="stylesheet/scss">
	.upload-file-wrapper {
		text-align: left;
		.error-hint {
			font-size: 12px;
			line-height: 1.8;
			padding: 4px 5px 3px;
			color: #ff4949;
		}
		.el-upload__tip {
			display: inline-block;
			margin-left: 10px;
		}
	}
	
	.file {
		position: relative;
		display: inline-block;
		background: #fff;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: 4px 12px;
		overflow: hidden;
		color: #606266;
		text-decoration: none;
		text-indent: 0;
		line-height: 20px;
		padding: 10px 20px;
		font-size: 14px;
		margin-top: 10px;
		input {
			position: absolute;
			font-size: 100px;
			right: 0;
			top: 0;
			opacity: 0;
			width: 98px;
			height: 30px;
		}
	}
	
	.file:hover {
		background: #ECF5FF;
		border-color: #C6E2FF;
		color: #409EFF;
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/upload_img/uploadfileqt.vue